module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-vimeo"
  }, [(_vm.isVimeo(_vm.med.video.link)) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.valvid)
    }
  })]) : _c('div', [_c('q-video', {
    staticStyle: {
      "height": "25vw !important"
    },
    attrs: {
      "src": _vm.getVid(_vm.med.video.link)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6342d0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/VideoVimeo.vue
// module id = 1278
// module chunks = 1